const pathPartToString = (index: string | number, i: number): string =>
  Number.isInteger(Number(index)) ? `[${index}]` : i === 0 ? `${index}` : `.${index}`;
export const pathToString = (path: (number | string)[]): string => path.map(pathPartToString).join("");
